import { Link } from "react-router-dom";
import { MessageCircle, ShoppingBag, Smartphone, CheckCircle2 } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { buildWhatsAppUrl } from "@/lib/helpers";

const ICONS = [Smartphone, ShoppingBag, MessageCircle, CheckCircle2];

export default function CaraPesan() {
  const { settings } = useStore();
  const steps = settings?.how_to_order || [];

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-10">
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight">Cara Pemesanan</h1>
      <p className="mt-2 text-muted-foreground">Belanja di {settings?.store_name} sangat mudah, ikuti langkah berikut:</p>

      <div className="mt-8 space-y-4">
        {steps.map((step, i) => {
          const Icon = ICONS[i % ICONS.length];
          return (
            <div key={i} className="flex items-start gap-4 rounded-2xl border border-border bg-card p-5 animate-fade-up" style={{ animationDelay: `${i * 80}ms` }}>
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent/10 text-accent"><Icon className="h-5 w-5" /></div>
              <div>
                <span className="text-xs font-bold uppercase tracking-wider text-accent">Langkah {i + 1}</span>
                <p className="mt-0.5 font-medium">{step}</p>
              </div>
            </div>
          );
        })}
      </div>

      {settings?.shipping_note && (
        <div className="mt-8 rounded-2xl bg-secondary p-5 text-sm">
          <span className="font-semibold">Info Pengiriman: </span>{settings.shipping_note}
        </div>
      )}

      <div className="mt-8 flex flex-col sm:flex-row gap-3">
        <Link to="/katalog" className="flex-1 rounded-2xl bg-primary py-3.5 text-center font-semibold text-primary-foreground hover:opacity-90">Mulai Belanja</Link>
        <button
          onClick={() => window.open(buildWhatsAppUrl(settings?.whatsapp_number, `Halo Admin ${settings?.store_name}, saya mau bertanya soal pemesanan.`), "_blank")}
          className="flex-1 flex items-center justify-center gap-2 rounded-2xl bg-whatsapp py-3.5 font-semibold text-white hover:opacity-90"
        >
          <MessageCircle className="h-5 w-5" /> Chat Admin
        </button>
      </div>
    </div>
  );
}
